import BulkSendMessageList from './bulkSendMessageList';
import BulkSendMessageShow from './bulkSendMessageShow';
import BulkSendMessageCreate from './bulkSendMessageCreate';

export default {
    list: BulkSendMessageList,
    show: BulkSendMessageShow,
    create: BulkSendMessageCreate
}